<template>
  <div class="page-content">
    <div class="flex-view">
      <img src="@/assets/images/gov/img02.png" alt="" />
      <div class="view-info">
        <div class="page-title">The Secretariat</div>
        <div class="text">
          （Text No.8）The appointed Secretary General shall make an organic
          framework towards the Bureau, which adopts it after consulting the
          Executive Board. This framework also describes the vacancies he or she
          wants to create in the secretariat.
        </div>
        <div class="page-title">Secretary-general's message</div>
        <div class="text">
          （Text No.9）The appointed Secretary General shall make an organic
          framework towards the Bureau, which adopts it after consulting the
          Executive Board. This framework also describes the vacancies he or she
          wants to create in the secretariat.
        </div>
      </div>
    </div>
    <div class="people-view">
      <el-row :gutter="20" class="people-row">
        <el-col :span="12">
          <div class="title">Secretary-General</div>
          <img src="@/assets/images/gov/people01.png" />
          <div class="name">Mr. Yue DU</div>
          <div class="country">Country：China</div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
export default {
  name: "strategy",
  components: {},
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
.mobile {
  .page-content {

    .flex-view {
      flex-wrap: wrap;
      >img {
        width: 100% !important;
        margin-bottom: 20px;
      }
    }
    .people-view .el-col-12{
      margin-bottom: 20px;
      img {
        width: 100%;
      }
      .title {
        font-size: 18px !important;
        line-height: 24px !important;
        min-height: 30px !important;
      }
      .name {
        font-size: 16px !important;
        line-height: 20px !important;
        min-height: 26px !important;
      }
    }
  }
}
.page-content {
  width: 100%;
  > img {
    width: fw(400vw, pc);
    height: fw(400vw, pc);
    display: block;
  }
  .people-view {
    .el-col-12 {
      margin-bottom: fh(60vh, pc);
      margin-top: fh(25vh, pc);
    }
    .title {
      font-size: fh(36vh, pc);
      font-weight: bold;
      color: #333;
      margin-bottom: fh(15vh, pc);
    }
    img {
      width: fw(182vw, pc);
      margin-top: fh(18vh, pc);
      margin-bottom: fh(20vh, pc);
    }
    .name {
      font-size: fh(24vh, pc);
      line-height: fh(36vh, pc);
      font-weight: bold;
      color: #333;
      margin-bottom: fh(15vh, pc);
    }
    .country {
      font-size: fh(18vh, pc);
      line-height: fh(36vh, pc);
      color: #2a2a2a;
    }
  }
  .page-title {
    font-weight: bold;
    font-size: fh(36vh, pc);
    color: #333333;
    line-height: fh(42vh, pc);
    text-align: justify;
  }
  .text {
    margin-top: fh(12vh, pc);
    font-size: fh(16vh, pc);
    color: #2a2a2a;
    line-height: fh(28vh, pc);
  }
  .flex-view {
    width: 100%;
    display: flex;
    align-items: flex-start;
    img {
      width: fw(360vw, pc);
      display: block;
      margin-right: fw(20vw, pc);
    }
    .view-info {
      flex: 1;
      .text {
        margin-top: fh(12vh, pc);
        margin-bottom: fh(60vh, pc);
      }
    }
  }
}
</style>
